<template>
    <div>
        <div class="py-4 px-3 flex flex-wrap flex-lg-nowrap items-stretch company-information-section">

            <div class="flex-col w-full lg:w-1/3 pr-4">
                <b-tabs v-model="activeTab" content-class="mt-3" lazy>
                    <b-tab id="create-new-tab" title="Create New">
                        <div class="mb-2">
                            <label class="text-grey-darkest text-sm" for="new_contact_name"
                                   :class="{'text-red': newContactForm.errors.has('name')}">Name</label>
                            <input v-model="newContactForm.name" id="new_contact_name" name="name"
                                   maxlength="64"
                                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                   :class="{'border-red': newContactForm.errors.has('name')}">
                            <div class="text-red text-xs" v-if="newContactForm.errors.has('name')">{{
                                    newContactForm.errors.get('name')
                                }}
                            </div>
                        </div>
                        <div class="mb-2" v-show="(teamResidentialContactType && teamResidentialContactType.id && newContactForm.contact_types_id === teamResidentialContactType.id)">
                            <label class="text-grey-darkest text-sm" for="searchTextFieldCompanyContact"
                                   :class="{'text-red': newContactForm.errors.has('address')}">Address</label>
                            <input v-model="newContactForm.address" id="searchTextFieldCompanyContact" name="address"
                                   maxlength="64" @focusin="initAutocompleteCompanyContact"
                                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                   :class="{'border-red': newContactForm.errors.has('address')}">
                            <div class="text-red text-xs" v-if="newContactForm.errors.has('address')">{{
                                    newContactForm.errors.get('address')
                                }}
                            </div>
                            <input v-model="newContactForm.lat" type="hidden" name="lat"
                                   class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                            <input v-model="newContactForm.lng" type="hidden" name="lng"
                                   class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                        </div>
                        <div class="mb-2" v-show="(teamResidentialContactType && teamResidentialContactType.id && newContactForm.contact_types_id === teamResidentialContactType.id)">
                            <label class="text-grey-darkest text-sm" for="new_contact_city"
                                   :class="{'text-red': newContactForm.errors.has('city')}">City</label>
                            <input v-model="newContactForm.city" id="new_contact_city" name="city"
                                   maxlength="64"
                                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                   :class="{'border-red': newContactForm.errors.has('city')}">
                            <div class="text-red text-xs" v-if="newContactForm.errors.has('city')">{{
                                    newContactForm.errors.get('city')
                                }}
                            </div>
                        </div>
                        <div class="mb-2" v-show="(teamResidentialContactType && teamResidentialContactType.id && newContactForm.contact_types_id === teamResidentialContactType.id)">
                            <label class="text-grey-darkest text-sm" for="new_contact_state"
                                   :class="{'text-red': newContactForm.errors.has('state')}">State</label>
                            <input v-model="newContactForm.state" id="new_contact_state" name="state"
                                   maxlength="64"
                                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                   :class="{'border-red': newContactForm.errors.has('state')}">
                            <div class="text-red text-xs" v-if="newContactForm.errors.has('state')">{{
                                    newContactForm.errors.get('state')
                                }}
                            </div>
                        </div>
                        <div class="mb-2" v-show="(teamResidentialContactType && teamResidentialContactType.id && newContactForm.contact_types_id === teamResidentialContactType.id)">
                            <label class="text-grey-darkest text-sm" for="new_contact_zip"
                                   :class="{'text-red': newContactForm.errors.has('zip')}">Zip</label>
                            <input v-model="newContactForm.zip" id="new_contact_zip" name="zip"
                                   maxlength="64"
                                   class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                   :class="{'border-red': newContactForm.errors.has('zip')}">
                            <div class="text-red text-xs" v-if="newContactForm.errors.has('zip')">{{
                                    newContactForm.errors.get('zip')
                                }}
                            </div>
                        </div>
                        <div class="mb-2">
                            <label class="text-sm text-grey-darkest -mb-0" for="email"
                                   :class="{'text-red': newContactForm.errors.has('email')}">Email</label>
                            <input
                                class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                :class="{'border-red': newContactForm.errors.has('email')}"
                                type="text" id="email" v-model="newContactForm.email">
                            <div class="text-red text-xs" v-if="newContactForm.errors.has('email')">{{
                                    newContactForm.errors.get('email')
                                }}
                            </div>
                            <div v-if="emailExists" class="text-red text-md mt-1">A contact with this email exists. <button class="btn btn-sm btn-primary" @click="addContactToProject">Add to Project</button></div>
                        </div>

                        <div class="mb-2">
                            <label class="text-sm text-grey-darkest -mb-0" for="cell"
                                   :class="{'text-red': newContactForm.errors.has('cell')}">Cell</label>
                            <input
                                class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                type="text" id="cell" v-model="newContactForm.cell">
                            <div class="text-red text-xs" v-if="newContactForm.errors.has('cell')">{{
                                    newContactForm.errors.get('cell')
                                }}
                            </div>
                        </div>
                        <div class="mb-2">
                            <label class="text-sm text-grey-darkest -mb-0" for="new_contact_title"
                                   :class="{'text-red': newContactForm.errors.has('title')}">Title</label>
                            <input
                                class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                type="text" id="new_contact_title" v-model="newContactForm.title">
                            <div class="text-red text-xs" v-if="newContactForm.errors.has('title')">{{
                                    newContactForm.errors.get('title')
                                }}
                            </div>
                        </div>
                        <div class="mb-2">
                            <label class="text-sm text-grey-darkest -mb-0" for="new_contact_date"
                                   :class="{'text-red': newContactForm.errors.has('date')}">Follow Up</label>
                            <div class="flex">
<!--                                <datetime type="datetime" id="new_contact_date" name="date"
                                          v-model="newContactForm.date" use12-hour
                                          class="w-full"
                                          :week-start="7"
                                          :format="masks.date_time_mask"
                                          :use-utc="true"
                                          input-class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                          @input="newContactForm.errors.clear('date')">
                                </datetime>-->
                                <projectDatetime  type="datetime"
                                                 name="date" id="new_contact_date"
                                                 v-model="newContactForm.date" use12-hour
                                                 autofill="off"
                                                 class="w-full"
                                                 :week-start="7"
                                                 :format="masks.date_time_mask"
                                                 :use-utc="true"
                                                 :minute-step="15"
                                                 input-class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                                 @input="newContactForm.errors.clear('date')">
                                </projectDatetime>
                                <button v-if="newContactForm.date &&  typeof newContactForm.date === 'string'" @click.prevent.stop="removeNewContactDate"
                                        class="material-icons text-grey-darkest text-xl focus:outline-none">clear
                                </button>
                            </div>
                            <div class="text-red text-xs" v-if="newContactForm.errors.has('date')">{{
                                    newContactForm.errors.get('date')
                                }}
                            </div>
                        </div>
                        <div class="mb-2">
                            <label class="text-sm text-grey-darkest -mb-0"
                                   :class="{'text-red': newContactForm.errors.has('user')}">User</label>
                            <multiselect
                                class="cursor-pointer"
                                :options="usersForContact"
                                v-model="newContactForm.user"
                                :show-labels="false"
                                @input="newContactForm.errors.clear('user')"
                                track-by="id"
                                label="name"
                                value="id">
                            </multiselect>
                            <div class="text-red text-xs" v-if="newContactForm.errors.has('user')">{{
                                    newContactForm.errors.get('user')
                                }}
                            </div>
                        </div>
                        <div class="mb-2">
                            <label class="text-sm text-grey-darkest -mb-0"
                                   :class="{'text-red': newContactForm.errors.has('contact_types_id')}">Contact Type</label>
                            <multiselect
                                class="cursor-pointer"
                                :options="allContactTypes"
                                v-model="selectedContactType"
                                :show-labels="false"
                                @input="newContactForm.errors.clear('contact_types_id')"
                                track-by="id"
                                label="code"
                                value="id">
                            </multiselect>
                            <div class="text-red text-xs" v-if="newContactForm.errors.has('contact_types_id')">
                                The contact type field is required.
                            </div>
                        </div>
                        <div class="mb-2 flex">
                            <div class="w-50 mr-2">
                                <label class="text-sm text-grey-darkest -mb-0"
                                       :class="{'text-red': newContactForm.errors.has('existing_company')}">Existing Company</label>
                                <div class="relative" ref="companyDropdownContainer">
                                    <input type="text"
                                           class="w-full pr-10 pl-4 py-2 border rounded focus:outline-none"
                                           v-model="displayValue"
                                           @input="handleCompanyInput"
                                           @focus="showCompanyDropdown = true"
                                           placeholder="Search companies..."
                                           :disabled="isExistingCompanyInputDisabled">
                                    <div class="absolute" style="top: 6px; right: 35px;" v-if="isLoadingCompanies">
                                        <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                                    </div>
                                    <i class="absolute fa fa-search mt-2 mr-2 custom-search-icon" aria-hidden="true"></i>

                                    <!-- Company Dropdown -->
                                    <div v-if="showCompanyDropdown"
                                         class="absolute z-50 w-full mt-1 bg-white border rounded shadow-lg company-dropdown-container"
                                         @scroll="handleCompanyScroll"
                                         ref="companyDropdown">
                                        <div v-if="searchedCompanies.length === 0 && !isLoadingCompanies"
                                             class="p-2 text-gray-500 text-center">
                                            No companies found
                                        </div>
                                        <div v-else class="company-dropdown-list">
                                            <div v-for="company in searchedCompanies"
                                                 :key="company.id"
                                                 class="p-2 hover:bg-gray-100 cursor-pointer company-dropdown-item"
                                                 @click="selectCompany(company)">
                                                {{ company.name }}
                                            </div>
                                            <div v-if="isLoadingMoreCompanies" class="p-2 text-center">
                                                <i class="fa fa-spinner fa-spin" aria-hidden="true"></i> Loading more...
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-red text-xs" v-if="newContactForm.errors.has('existing_company')">{{newContactForm.errors.get('existing_company')}}</div>
                                <div class="text-red text-xs" v-show="customErrors.existing_company != null">{{ customErrors.existing_company }}</div>
                            </div>
                            <div class="w-50 ml-2">
                                <label class="text-sm text-grey-darkest -mb-0" :class="{'text-red': newContactForm.errors.has('new_company')}">New Company</label>
                                <input
                                  class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                  type="text" id="new_company" v-model="newContactForm.new_company" style="height: 37px;" :disabled="isNewCompanyInputDisabled" @input="remove_validations()">
                                <div class="text-red text-xs" v-if="newContactForm.errors.has('new_company')">{{
                                      newContactForm.errors.get('new_company')
                                    }}
                                </div>
                                <div class="text-red text-xs" v-show="customErrors.new_company != null">{{ customErrors.new_company }}</div>
                            </div>

                        </div>
                        <div class="mb-2 flex justify-between">
                            <button class="btn btn-secondary" @click="switchToExistingTab">Cancel</button>
                            <button :class="isCreateDisabled ? 'btn btn-secondary' : 'btn btn-primary'" :disabled="isCreateDisabled" @click="saveContact">Create & Add</button>
                        </div>
                    </b-tab>
                    <b-tab id="add-existing-tab" title="Add Existing" >

                        <div class="relative">
                            <input type="text" class="w-full pr-10 pl-4 py-2 border rounded focus:outline-none" placeholder="Search a company..."
                                   v-model="filter.company_name"
                                   @input="debounceFilter">
                            <div class="absolute" style="top: 6px; right: 35px;" v-if="isLoadingContacts">
                                <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                            </div>
                            <i class="absolute fa fa-search mt-2 mr-2 custom-search-icon" aria-hidden="true"></i>
<!--                            <multiselect-->
<!--                                id="companies"-->
<!--                                v-model="selectedCompany"-->
<!--                                @input="fetchContacts"-->
<!--                                :options="allCompanies"-->
<!--                                :multiple="false"-->
<!--                                :close-on-select="true"-->
<!--                                :clear-on-select="false"-->
<!--                                :preserve-search="false"-->
<!--                                :taggable="true"-->
<!--                                open-direction="below"-->
<!--                                placeholder="Pick a company"-->
<!--                                label="name"-->
<!--                                track-by="id"-->
<!--                                :preselect-first="false"-->
<!--                                :class="errors.has('company_contacts') ? 'required-field-color' : ''">-->
<!--                            </multiselect>-->
                            <div class="text-red text-xs" v-if="errors.has('company_contacts')">{{errors.get('company_contacts')}}</div>
                        </div>
                        <div class="flex justify-between" v-if="contacts.length > 0 || selectedCompanyContacts.length > 0 ">
                            <div class="mb-1 text-grey-darkest text-sm">{{ contacts.length }} results</div>
                            <div class="mb-1 text-grey-darkest text-sm">{{selectedCompanyContacts.length}} selected</div>
                        </div>
                        <div v-if="selectedCompanyContacts.length > 0">
                            <label class="font-medium text-grey-darkest text-md mb-2">Selected</label>
                            <div class="leading-tight selected-contact-result-section">
                                <div class="flex justify-between mb-2 mr-2"  v-for="(selectedCompanyContact, selectedCompanyContactIndex) in selectedCompanyContacts">
                                    <div class="flex w-3/5">
                                      <b-form-checkbox
                                          :id="'company-contact-selected-'+selectedCompanyContact.contact_company_unique_id"
                                          :name="'company-contact-selected-'+selectedCompanyContact.contact_company_unique_id"
                                          v-model="selectedCompanyContact.project_temp_check"
                                          value=1
                                          unchecked-value=0
                                          class="company-contact-margin"
                                          @change="removeSelectedContact(selectedCompanyContact, selectedCompanyContactIndex)"
                                      >
                                      </b-form-checkbox>
                                        <div class="mr-3 text-base text-grey-darkest ellipsis">{{ selectedCompanyContact.name }}</div>
                                    </div>
                                    <div class="active w-2/5 ellipsis tooltips-company-selected-title-class" data-toggle="tooltip" data-placement="top" :title="selectedCompanyContact.company_name">{{ selectedCompanyContact.company_name }}</div>

                                </div>
                            </div>
                        </div>

                        <div v-if="contacts.length > 0">
                            <hr class="lg:hidden">
                            <label class="font-medium text-grey-darkest text-md mb-2">All results</label>
                            <div class="leading-tight contact-result-section">
                                <div class="flex justify-between mb-2 mr-2"  v-for="(contact, contactIndex) in contacts">
                                    <div class="flex w-3/5">
                                      <b-form-checkbox
                                        :id="'company-contacts-'+contact.contact_company_unique_id"
                                        v-model="contact.project_temp_check"
                                        :name="'company-contacts-'+contact.contact_company_unique_id"
                                        value=1
                                        unchecked-value=0
                                        @change="selectCompanyContact(contact, contactIndex)"
                                        class="company-contact-margin"
                                        >
                                      </b-form-checkbox>
                                        <div class="mr-3 text-base text-grey-darkest ellipsis">{{ contact.name }}</div>
                                    </div>
                                    <div class="active w-2/5 ellipsis tooltips-company-title-class" data-toggle="tooltip" data-placement="top" :title="contact.company_name">{{ contact.company_name }}</div>

                                </div>
                            </div>
                        </div>
                        <!-- Add Existing content here -->
                        <div v-if="selectedCompanyContacts.length > 0" class="flex justify-content-end mt-3">
                            <button @click="addSelectedCompanyContact" class="btn border-1 border-grey mr-1 btn-primary" >Add Now</button>
                        </div>
                    </b-tab>
                </b-tabs>
            </div>
            <div class="hidden lg:flex border-1 border-grey mr-4"></div>
            <div class="flex-1 lg:w-2/3 overflow-auto">
                <hr class="lg:hidden">
                <div v-if="data_loading">
                    <div class="text-5xl text-grey-darkest text-center">
                        <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                    </div>
                    <div class="text-center">Loading</div>
                </div>
                <div v-else>
                    <table class="w-full" v-if="shouldShowCreateSection">
                        <tbody>
                        <tr v-if="data_loading">
                            <td colspan="11" class="text-5xl text-grey-darkest text-center mt-32">
                                <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                            </td>
                        </tr>
                        <tr v-for="contact in company_contacts"
                            class="hover:bg-grey-lighter rounded cursor-pointer">
                            <td v-if="foundationCustomerAccess" class="text-center">
                                <input v-if="contact.foundation_customer_no"
                                       type="radio"
                                       v-model="foundationContactSelectedContact"
                                       :value="contact.id"
                                       :name="'contact' + contact.id"
                                       :key="contact.id">
                                <button type="button" v-else @click="contactPushToFoundation(contact)" class="cursor-pointer border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:text-white px-1 py-2 rounded-full text-base text-followup-nav" style="font-size: 11px">
                                    <i :class="'fa fa-spin fa-spinner text-grey-darkest push-to-foundation-loader-' + contact.id" aria-hidden="true" style="display: none;"></i>
                                    Push To Foundation
                                </button>
                            </td>
                            <td v-if="sageIntacctContactSyncAccess" class="text-center">
                                <input v-if="contact.sage_intacct_customer_no"
                                       type="radio"
                                       v-model="sageIntacctContactSelectedContact"
                                       :value="contact.id"
                                       :name="'contact' + contact.id"
                                       :key="contact.id">
                                <button type="button" v-else @click="contactPushToSageIntacct(contact)" class="cursor-pointer border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:text-white px-1 py-2 rounded-full text-base text-followup-nav" style="font-size: 11px">
                                    <i :class="'fa fa-spin fa-spinner text-grey-darkest push-to-foundation-loader-' + contact.id" aria-hidden="true" style="display: none;"></i>
                                    Push To Sage Intacct
                                </button>
                            </td>
                            <td class="p-2 text-base text-grey-darkest">{{ contact.company_name }}</td>
                            <td class="p-2 font-medium text-base text-grey-darkest">
                                {{ contact.name }}, {{ contact.title }}
                            </td>
                            <td class="p-2 text-sm font-light text-grey-darkest hidden lg:table-cell">
                                {{ contact.cell }}
                            </td>
                            <td class="p-2 text-sm font-light text-grey-darkest hidden lg:table-cell">
                                {{ contact.email }}
                            </td>
                            <td class="pt-2">
                                <button @click.prevent.stop="removeContact(contact)"
                                        class="focus:outline-none text-base font-light text-grey-darkest hover:text-grey-darkest material-icons">
                                    delete
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <!--   New Company information table Start-->
                    <table class="text-left w-full border-collapse table-bordered" id="project_index" v-else-if="company_contacts.length > 0" ref="ResizableTable">
                        <thead>
                        <tr>
                            <th></th>
                            <th v-if="foundationCustomerAccess" class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light whitespace-no-wrap md:table-cell">Foundation Sync</th>
                            <th v-if="sageIntacctContactSyncAccess" class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light whitespace-no-wrap md:table-cell">Sage Intacct Sync</th>
                            <th v-for="(column,index) in columnsToShow" :id="column.property_name"
                                class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light whitespace-no-wrap md:table-cell column-header-resize">
                                <div class="column-resize" :class="[(`${column.property_name}`), (column.property_name === 'bid_status' ? 'bid-status-column' : 'non-bid-status-column')]">
                                    <div class="font-bold uppercase text-xs text-grey-darkest hover:no-underline focus:outline-none" :style="{ width: getColumnWidth(column.property_name) + 'px' }" style="pointer-events: none;">
                                        {{ column.property_name === 'bid_status' ? column.name : getFieldLabel(fieldLabels, column.name.replace(/ /g, '-').toLowerCase()) }}
                                    </div>
                                </div>
                            </th>
                            <th class="py-1 px-2 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light hidden xl:table-cell md:table-cell">
                                <div class="d-flex justify-content-center">
                                    <div class="font-bold uppercase text-xs text-grey-darkest hover:no-underline focus:outline-none pr-2">
                                        Action
                                    </div>
                                    <contact-export-icon v-if="columns.length"
                                                         name="Contacts"
                                                         :contacts="company_contacts"
                                                         :state="columns"
                                                         :filter="[]"
                                                         :isListExport="false"
                                                         :list="null"
                                                         :isCompanyInformation="true"
                                                         v-on:updateCompanyInformationSection="updateCompanyInformationSection"
                                    />
                                </div>
                            </th>
                        </tr>
                        </thead>
                            <draggable
                        draggable=".company-infos"
                        v-model="company_contacts"
                        :element="'tbody'"
                        >
                            <tr v-for="(contact, idx) in company_contacts" class="company-infos" :key="idx" :style="getSafe(() => contact.company_type.is_competitor) ? { color: 'red !important' } : {}">
                                <td><i class="fa fa-align-justify handle text-black p-1" style="cursor: move;"></i></td>
                                <td v-if="foundationCustomerAccess" class="text-center" :style="getSafe(() => contact.company_type.is_competitor) ? { color: 'red !important' } : {}">
                                    <input v-if="contact.foundation_customer_no"
                                           type="radio"
                                           v-model="foundationContactSelectedContact"
                                           :value="contact.id"
                                           :name="'contact' + contact.id"
                                           :key="contact.id">
                                    <button type="button" v-else @click="contactPushToFoundation(contact)" class="cursor-pointer border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:text-white px-1 py-2 rounded-full text-base text-followup-nav" style="font-size: 11px">
                                        <i :class="'fa fa-spin fa-spinner text-grey-darkest push-to-foundation-loader-' + contact.id" aria-hidden="true" style="display: none;"></i>
                                        Push To Foundation
                                    </button>
                                </td>
                                <td v-if="sageIntacctContactSyncAccess" class="text-center" :style="getSafe(() => contact.company_type.is_competitor) ? { color: 'red !important' } : {}">
                                    <input v-if="contact.sage_intacct_customer_no"
                                           type="radio"
                                           v-model="sageIntacctContactSelectedContact"
                                           :value="contact.id"
                                           :name="'contact' + contact.id"
                                           :key="contact.id">
                                    <button type="button" v-else @click="contactPushToSageIntacct(contact)" class="cursor-pointer border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:text-white px-1 py-2 rounded-full text-base text-followup-nav" style="font-size: 11px">
                                        <i :class="'fa fa-spin fa-spinner text-grey-darkest push-to-foundation-loader-' + contact.id" aria-hidden="true" style="display: none;"></i>
                                        Push To Sage Intacct
                                    </button>
                                </td>
                                <td v-for="column in columnsToShow"
                                    class="pl-2 border-b border-grey-light text-xs md:table-cell">
                                    <a href="javascript:void(0)"
                                       @click="goToContact(contact.company_id, contact.id)"
                                       class="text-dark hover:text-teal-dark"
                                       v-show="column.property_name === 'name' && !column.is_sales_behavior"
                                       :title="contact[column.property_name]"
                                       style="word-break: break-all;"
:style="getSafe(() => contact.company_type.is_competitor) ? { color: 'red !important' } : {}">
                                        {{ contact[column.property_name] }}
                                    </a>
                                    <a href="javascript:void(0)"
                                       @click="goToCompany(contact.company_id, contact)"
                                       class="text-dark hover:text-teal-dark"
                                       v-show="column.property_name === 'company_name' && !contact.is_residential_company && !column.is_sales_behavior"
                                       :title="contact.company_name"
                                       style="word-break: break-all;"
:style="getSafe(() => contact.company_type.is_competitor) ? { color: 'red !important' } : {}">
                                        {{ contact.company_name }}
                                    </a>
                                    <span v-show="column.property_name === 'company_name' && contact.is_residential_company && !column.is_sales_behavior" style="word-break: break-all;">{{ contact.company_name }}</span>

                                    <a :href="'mailto:'+contact.email+mailSubject"
                                       class="text-dark hover:text-teal-dark"
                                       v-show="column.property_name === 'email' && !column.is_sales_behavior"
                                       :title="contact.email"
                                       style="word-break: break-all;"
:style="getSafe(() => contact.company_type.is_competitor) ? { color: 'red !important' } : {}">
                                        {{ contact.email }}
                                    </a>

                                    <span v-show="column.property_name !== 'base_bid' && column.property_name !== 'company_type' && column.property_name !== 'company_name' && column.property_name !== 'email' && column.property_name !== 'name' && column.property_name !== 'followup' && column.property_name !== 'bid_status' && !column.is_sales_behavior" style="word-break: break-all;" :style="getSafe(() => contact.company_type.is_competitor) ? { color: 'red !important' } : {}"> {{ contact[column.property_name] }}</span>
                                    <span v-if="column.is_sales_behavior" style="word-break: break-all;" :style="getSafe(() => contact.company_type.is_competitor) ? { color: 'red !important' } : {}"> {{ fetchSalesBehaviorData(contact, column) }}</span>

                                    <span v-if="column.property_name === 'company_type'" style="word-break: break-all;" :style="getSafe(() => contact.company_type.is_competitor) ? { color: 'red !important' } : {}"> {{ getSafe(() => contact.company_type.code) }}</span>

                                    <span class="flex justify-around" v-if="column.property_name === 'base_bid'">
                                        <!-- <input inputmode="decimal" :style="getSafe(() => contact.company_type.is_competitor) ? { color: 'red !important' } : {}" name="base_bid" type="text" v-model="contact.base_bid" style="padding: 3px;border: 1px solid #edf0f2;border-radius: 2px;box-shadow: 0px 0px 1px #6b6d6f;max-width: 70px;"/> -->
                                        <currency-input
                                            :style="getSafe(() => contact.company_type.is_competitor) ? { color: 'red !important' } : {}"
                                            id="base_bid"
                                            name="base_bid"
                                            v-model="contact.base_bid"
                                            locale="us"
                                            :currency="null"
                                            style="padding: 3px;border: 1px solid #edf0f2;border-radius: 2px;box-shadow: 0px 0px 1px #6b6d6f;max-width: 70px;">
                                        </currency-input>
                                    </span>

                                    <span class="flex justify-around" v-if="column.property_name === 'followup'">
                                        <projectDatetime type="datetime" id="date" name="date" v-model="contact.date" use12-hour
                                                  :format="masks.date_time_mask"
                                                  :week-start="7"
                                                  :input-class="(errors.has('company_contacts.'+idx+'.date'))? 'bg-white leading-normal tracking-wide shadow-sm appearance-none border-1 rounded text-grey-darkest w-full focus:outline-none border-red':'bg-white leading-normal tracking-wide shadow-sm appearance-none border-1 rounded text-grey-darkest w-full focus:outline-none'">
                                        </projectDatetime>
                                        <button type="button" v-if="contact.date && typeof contact.date === 'string'" @click.prevent.stop="removeMeeting(idx)"
                                                class="material-icons text-grey-darkest text-xl focus:outline-none">
                                            clear
                                        </button>
                                    </span>

                                    <span v-if="column.property_name === 'bid_status'">
                                         <select v-model="contact.status" name="status" id="status"
                                                :style="getSafe(() => contact.company_type.is_competitor) ? { color: 'red !important' } : {}"
                                                 :class="(errors.has('company_contacts.'+idx+'.status')) ? 'bg-white border-1 focus:outline-none text-grey-darkest text-sm border-red' : 'bg-white border-1 focus:outline-none text-grey-darkest text-sm'"
                                                 @change="resetValidationErrors('company_contacts.'+idx+'.status');checkAndRemoveKeys(contact);resetCompanyContactStatusValidation();">
                                            <option selected></option>
                                            <option value="no-bid">No Bid</option>
                                            <option value="pending">Pending</option>
                                            <option :disabled="isWonDisabled(contact)" value="won">Won</option>
                                            <option :disabled="isLostDisabled(contact)" value="lost">Lost</option>
                                            <option :disabled="isLostDisabled(contact)" value="lost-gc-awarded">Lost – GC Awarded</option>
                                            <option :disabled="isLostDisabled(contact)" value="lost-gc-not-awarded">Lost – GC Not Awarded</option>
                                        </select>
                                    </span>

                                </td>
                                <td class="px-2 border-b border-grey-light hidden xl:table-cell md:table-cell">
                                    <div class="flex justify-content-around" :style="getSafe(() => contact.company_type.is_competitor) ? { color: 'red !important' } : {}">
                                        <button v-if="canEdit" type="button" @click.prevent.stop="addComment(contact)"
                                                class="focus:outline-none text-md font-light text-grey-darkest hover:text-grey-darkest material-icons">
                                            add_comment
                                        </button>
                                        <button v-if="canEdit" type="button" @click.prevent.stop="addOrRemoveContact(contact);resetCompanyContactStatusValidation();"
                                                class="focus:outline-none text-md font-light text-grey-darkest hover:text-grey-darkest material-icons">
                                            delete
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </draggable>

                    </table>
                    <span v-if="foundationCustomerAccess" class="text-danger" style="font-size: 12px;">{{ foundationContactSyncedErrorMsg }}</span>
                    <span v-if="sageIntacctContactSyncAccess" class="text-danger" style="font-size: 12px;">{{ sageIntacctContactSyncedErrorMsg }}</span>
                    <div v-show="companyWonStatusRequired !== null" class="text-red text-sm mt-4"> {{ companyWonStatusRequired }}</div>
                </div>

            </div>
        </div>


        <div class="modal" id="pushContactToFoundationModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ externalCustomFieldModalTitle }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closePushContactToFoundationModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <div v-for="(field, index) in external_custom_fields" v-if="field.is_foundation_custom_id">
                                    <label class="text-grey-darkest text-sm float-left">{{field.label_value}}</label>
                                    <input type="text" v-model="externalFoundationCustomFieldValue"
                                           class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                           required>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="sendPushContactToFoundationRequest(true)">
                            <i class="fa fa-spin fa-spinner text-white" v-if="foundationContactPushLoader" aria-hidden="true"></i>
                            Push To Foundation
                        </button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closePushContactToFoundationModal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import axios from "axios";
import Swal from "sweetalert2";
import Form from "../../utils/form";
import draggable from "vuedraggable";
import inlineComment from "./inline-update/inline-comment.vue";
import pinProject from "./pin-project/pin-project.vue";
import ContactExportIcon from "./contact-export-icon.vue";
import salesBehaviors from "../settings/sales-behaviors.vue";
let autocomplete = null;

export default {
    name: 'company-information',
    components: {ContactExportIcon, pinProject, inlineComment, Multiselect, draggable},
    props: ['project', 'errors', 'masks', 'usersForContact', 'allContactTypes', 'foundationCustomerAccess',
      'sageIntacctContactSyncAccess', 'foundationContactSyncedErrorMsg', 'sageIntacctContactSyncedErrorMsg',
      'foundationContactSyncAccess', 'sectionType', 'resetValidationErrors', 'symbols', 'canEdit', 'addComment', 'companyContactIds',
        'team', 'mailSubject', 'companyWonStatusRequired', 'fieldLabels','companyAddCheck', 'teamResidentialContactType', 'canCreateCompany'],
    data() {
        return {
            selectedCompany: null,
            contacts: [],
            selectedCompanyContacts: [],
            company_contacts: [],
            foundationContactSelectedContact: null,
            sageIntacctContactSelectedContact: null,
            externalCustomFieldModalTitle: '',
            external_custom_fields: [],
            foundationContactPushLoader: false,
            selectedUserContact: null,
            selectedContactType: null,
            newContactForm: new Form({
                id: null,
                name: '',
                address: '',
                city: '',
                state: '',
                zip: '',
                lat: '',
                lng: '',
                email: '',
                cell: '',
                title: '',
                date: null,
                completed: null,
                contact_types_id: null,
                user: null,
                existing_company: null,
                new_company: null,
            }),
            activeTab: 1,
            emailExists: false,
            customErrors: {
                existing_company: null,
                new_company: null,
            },
            validate_companies: true,
            existingContact: null,
            statusWonDisabled: [],
            statusLostDisabled: [],
            filter: {
                company_name: '',
                timeout: null,
            },
            isLoadingContacts: false,
            currentOrder: {
                sortBy: 'contact_name',
                direction: 'desc'
            },
            columns:[],
            columnsToShow:[],
            data_loading: this.sectionType === 'projectEdit' || this.sectionType === 'projectCopy',
            existingContactIds: [],
            updatedColumns: [],
            columnWidths: {},
            isLoadingCompanies: false,
            currentPage: 1,
            lastPage: 1,
            perPage: 10,
            totalItems: 0,
            isLoadingMore: false,
            searchQuery: '',
            allCompanies: [], // Initialize as empty array
            companySearchQuery: '',
            displayValue: '',
            showCompanyDropdown: false,
            searchedCompanies: [],
            companyPage: 1,
            companyPerPage: 20,
            isLoadingMoreCompanies: false,
            hasMoreCompanies: true,
            companySearchTimeout: null,
        };
    },
    watch: {
        company_contacts: {
            handler: function (val, oldVal) {
               this.$parent.form.company_contacts = this.company_contacts
            },
            deep: true
        },
        sageIntacctContactSelectedContact: {
            handler: function (val, oldVal) {
                this.$parent.form.sageIntacctContactSelectedContact = this.sageIntacctContactSelectedContact
            },
        },
        foundationContactSelectedContact: {
            handler: function (val, oldVal) {
                this.$parent.form.foundationContactSelectedContact = this.foundationContactSelectedContact
            },
        },
        selectedContactType: function(val, oldVal) { // Correctly defined watcher
            this.newContactForm.contact_types_id = val ? val.id : null;
            if (val) {
                if (val.is_residential) {
                    this.newContactForm.existing_company = null;
                    this.newContactForm.new_company = null;
                    this.validate_companies = false;
                    this.customErrors = {
                        existing_company: null,
                        new_company: null,
                    };
                } else {
                    this.validate_companies = true;
                }
            }
        },
        'newContactForm.existing_company': {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.displayValue = newVal.name;
                }
            }
        },
        activeTab: {
            handler(newVal) {
                if (newVal === 0) { // 0 is the index for "Create New" tab
                    this.resetCreateForm();
                    this.displayValue = '';
                    this.showCompanyDropdown = false;
                }
            }
        }
    },
    created() {
        if(this.sectionType === 'projectEdit' || this.sectionType === 'projectCopy'){
            this.fetchState();
        }
    },
    mounted() {
        if(this.sectionType === 'projectEdit' || this.sectionType === 'projectCopy'){
            this.existingContactIds = this.project.company_contacts.map(contact => contact.contact_company_unique_id);
        }
        this.addToolTipForContacts();
        // Add click outside listener
        document.addEventListener('click', this.handleClickOutside);
        // Load initial companies
        this.loadCompanies();
    },
    beforeDestroy() {
        // Remove click outside listener
        document.removeEventListener('click', this.handleClickOutside);
    },
    methods: {
        isProjectCreateRoute() {
            return window.location.href.includes('project/create');
        },
        resetCreateForm() {
            this.newContactForm.reset();
            this.emailExists = false;
            this.validate_companies = true;
            this.existingContact = null;
            this.selectedContactType = null;
            this.displayValue = '';
            this.customErrors = {
                existing_company: null,
                new_company: null,
            };
        },
        fetchContacts() {
            if (this.selectedCompany) {
                axios.get(route('api.company.contacts', {company: this.selectedCompany.id})).then(({data}) => {
                    this.contacts = data.data;
                });
            } else {
                this.contacts = [];
            }

        },
        fetchState() {
            axios.get(route('api.project-company-information-state.get')).then(({data}) => {
               this.columnsToShow = data.columnsToShow
               this.columns = data.state
                if(!Array.isArray(data.columnWidth)){
                    this.columnWidths = data.columnWidth;
                }


                let contactIds = this.company_contacts.length > 0 ? this.company_contacts.map(contact => contact.contact_company_unique_id) :  this.existingContactIds;
                if(this.selectedCompanyContacts.length > 0) {
                    const selectedContactIds = this.selectedCompanyContacts.map(contact => contact.contact_company_unique_id);
                    contactIds = contactIds.concat(selectedContactIds);
                }
                this.fetchCompanyContacts(contactIds, this.project.id, this.columnsToShow, true);
            });
        },
        contactAddedAlready(contact) {
            return this.company_contacts.filter(x => contact.contact_company_unique_id === x.contact_company_unique_id).length > 0;
        },
        selectCompanyContact(contact, contactIndex) {

          this.$nextTick(() => {
            const exists = this.selectedCompanyContacts.find(
                (selectedContact) => selectedContact.contact_company_unique_id === contact.contact_company_unique_id
            );
            const alreadyAdded = this.contactAddedAlready(contact);

            if (alreadyAdded) {
              this.getToast().fire({
                type: 'error',
                title: "Contact is already added to the form"
              });
              this.contacts[contactIndex].project_temp_check = 0;
            } else {
              if (!exists) {
                this.selectedCompanyContacts.push(contact);
              } else {
                this.selectedCompanyContacts = this.selectedCompanyContacts.filter(
                    (selectedContact) => selectedContact.contact_company_unique_id !== contact.contact_company_unique_id
                );
              }
            }
          });
            this.addToolTipForContacts();
        },
        removeSelectedContact(contact, selectedCompanyContactIndex){
            this.$nextTick(() => {
                this.selectedCompanyContacts = this.selectedCompanyContacts.filter(
                    (selectedContact) => selectedContact.contact_company_unique_id !== contact.contact_company_unique_id
                );
                this.contacts[selectedCompanyContactIndex].project_temp_check = 0;
            })
            this.addToolTipForContacts();
        },
        async addSelectedCompanyContact(event) {

            event.preventDefault();
            const selectedContactIds = this.selectedCompanyContacts.map(contact => contact.contact_company_unique_id);
            await this.fetchCompanyContacts(selectedContactIds, null, this.columnsToShow);
            // this.selectedCompanyContacts.map(contact => this.addContact(contact))
            this.selectedCompany = null;
            this.contacts = [];
            this.selectedCompanyContacts = [];
            this.$emit('companyAddCheck',true);
        },
        async fetchCompanyContacts(contactIds, projectId, columns, replace = false){

            let params = {
                "contactIds": contactIds,
                "projectId": projectId,
                "columns": Object.values(columns).length > 0 ? Object.values(columns).map(column => column.property_name) : [],
                "sectionType": this.sectionType,
            }

            await axios.post(route('api.project.company-contacts-detail'), params).then(({data}) => {
                this.data_loading = false;
                if(data.contacts.length){
                    if(replace){
                        this.company_contacts = [];
                    }
                    data.contacts.map(contact => this.addContact(contact))
                }
                if(this.sectionType === 'projectEdit' || this.sectionType === 'projectCopy'){
                    this.$nextTick(()=>{
                        this.setResizeListeners();
                    })
                }
            });
            this.addToolTipForContacts();
        },
        contactPushToSageIntacct(contact) {
            let self = this;
            $('.push-to-foundation-loader-' + contact.id).show();
            if (!contact.is_contact_residential && contact.contact_synced_to_sage_intacct) {
                Swal.fire({
                    title: 'Push Contact in Sage Intacct',
                    text: "A customer record already exists on Sage Intacct with this customer number & company name. Do you want to replace the existing Primary Contact on Sage Intaact?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: 'Continue push!'
                }).then((result) => {
                    if (result.value) {
                        self.selectedContactForPushSageIntacct = contact;
                        let payload = {'team': self.team, 'company': contact.company, 'contact': contact,'sageIntactSyncedContact': contact.contact_synced_to_sage_intacct};
                        axios.post(route('api.company.sync-sage-intact-contact'), payload).then((result) => {
                            $('.push-to-foundation-loader-' + contact.id).show();
                            Swal.fire({
                                title: result.data.sageInacctCustomerNo ? 'Created' : 'Sage Intacct Error',
                                text: result.data.sageInacctCustomerNo ? result.data.sageInacctMsg : result.data.message,
                                type: result.data.sageInacctCustomerNo ? 'success' : 'error',
                                showCancelButton: false,
                                confirmButtonColor: '#01B1AF',
                                confirmButtonText: 'OK!',
                                closeOnConfirm: false,
                            }).then(() => {
                                $('.push-to-foundation-loader-' + contact.id).hide();
                                if(result.data.sageInacctCustomerNo) {
                                    let addedContactIds = _.map(self.company_contacts, 'id');
                                    self.updateAddedContactsAfterFoundationPush(addedContactIds);
                                }
                            });
                        }).catch(() => {
                            $('.push-to-foundation-loader-' + contact.id).hide();
                            Swal.fire({
                                title: 'Sage Intacct Error',
                                text: "Create on Sage Intacct Failed.",
                                type: 'error',
                                showCancelButton: false,
                                confirmButtonColor: '#01B1AF',
                                confirmButtonText: 'OK!',
                                closeOnConfirm: false,
                            }).then(() => {
                                //
                            });
                        });
                    } else {
                        $('.push-to-foundation-loader-' + contact.id).hide();
                    }
                });
            } else {
                self.selectedContactForPushSageIntacct = contact;
                if (contact.is_contact_residential) {
                    let payload = {
                        'contact': contact,
                        'company': contact.company
                    };
                    axios.post(route('api.contact.sage-intacct.push-residential-contact'), payload).then((result) => {
                        if (result.data.sageInatcctCustomerNo) {
                            let addedContactIds = _.map(self.company_contacts, 'id');
                            self.updateAddedContactsAfterFoundationPush(addedContactIds);
                        }
                        Swal.fire({
                            title: result.data.sageInatcctCustomerNo ? 'Created' : 'Sage Intact Error',
                            text: result.data.message,
                            type: result.data.sageInatcctCustomerNo ? 'success' : 'error',
                            showCancelButton: false,
                            confirmButtonColor: '#01B1AF',
                            confirmButtonText: 'OK!',
                            closeOnConfirm: false,
                        });
                    }).catch(() => {
                        Swal.fire({
                            title: 'Sage Intact Error',
                            text: "Create on Sage Intact Failed.",
                            type: 'error',
                            showCancelButton: false,
                            confirmButtonColor: '#01B1AF',
                            confirmButtonText: 'OK!',
                            closeOnConfirm: false,
                        });
                    });
                    $('.push-to-foundation-loader-' + contact.id).hide();
                }else {
                    self.selectedContactForPushSageIntacct = contact;
                    let payload = {'team': self.team, 'company': contact.company, 'contact': contact,'sageIntactSyncedContact': null};
                    axios.post(route('api.company.sync-sage-intact-contact'), payload).then((result) => {
                        $('.push-to-foundation-loader-' + contact.id).show();
                        Swal.fire({
                            title: result.data.sageInacctCustomerNo ? 'Created' : 'Sage Intacct Error',
                            text: result.data.sageInacctCustomerNo ? result.data.sageInacctMsg : result.data.message,
                            type: result.data.sageInacctCustomerNo ? 'success' : 'error',
                            showCancelButton: false,
                            confirmButtonColor: '#01B1AF',
                            confirmButtonText: 'OK!',
                            closeOnConfirm: false,
                        }).then(() => {
                            $('.push-to-foundation-loader-' + contact.id).hide();
                            if(result.data.sageInacctCustomerNo) {
                                let addedContactIds = _.map(self.company_contacts, 'id');
                                self.updateAddedContactsAfterFoundationPush(addedContactIds);
                            }
                        });
                    }).catch(() => {
                        $('.push-to-foundation-loader-' + contact.id).hide();
                        Swal.fire({
                            title: 'Sage Intacct Error',
                            text: "Create on Sage Intacct Failed.",
                            type: 'error',
                            showCancelButton: false,
                            confirmButtonColor: '#01B1AF',
                            confirmButtonText: 'OK!',
                            closeOnConfirm: false,
                        }).then(() => {
                            //
                        });
                    });
                }
            }
        },
        updateAddedContactsAfterFoundationPush(addedContactIds) {
            let self = this;
            axios.post(route('api.contact.get-details'), {contactIds: JSON.stringify(addedContactIds)}).then(({data}) => {
                _.forEach(addedContactIds, function(contactId) {
                    let contactData = _.find(data.data, {id: contactId});
                    self.company_contacts = self.company_contacts.map(item => {
                        if(item.id === contactId) {
                            item.foundation_customer_no = contactData.foundation_customer_no;
                            item.sage_intacct_customer_no = contactData.sage_intacct_customer_no;
                            item.sage_intacct_record_no = contactData.sage_intacct_record_no;
                            item.contact_synced_to_sage_intacct = contactData.contact_synced_to_sage_intacct;
                        }
                        return item;
                    });
                });
            });
        },
        contactPushToFoundation(contact) {
            let self = this;
            $('.push-to-foundation-loader-' + contact.id).show();
            if(!contact.is_contact_residential && contact.is_any_contact_synced_to_foundation) {
                Swal.fire({
                    title: 'Push Contact to Foundation',
                    text: "A customer record already exists on Foundation with this customer number & company name. Do you want to replace this customer record with this contact?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: 'Continue push!'
                }).then((result) => {
                    if (result.value) {
                        self.selectedContactForPushFoundation = contact;
                        if(contact.is_contact_residential) {
                            if(self.isContactHasCustomCustomerNoField && !self.isContactCustomCustomerNoAutoGenerated) {
                                self.external_custom_fields = self.contact_custom_fields;
                                self.externalCustomFieldModalTitle = 'Foundation Custom Customer #';
                                $('#pushContactToFoundationModal').modal('show');
                            }
                            else {
                                self.sendPushContactToFoundationRequest();
                            }
                        }
                        else {
                            if(self.isCompanyHasCustomCustomerNoField && !self.isCompanyCustomCustomerNoAutoGenerated) {
                                self.external_custom_fields = self.company_custom_fields;
                                self.externalCustomFieldModalTitle = 'Foundation Custom Customer #';
                                $('#pushContactToFoundationModal').modal('show');
                            }
                            else {
                                self.sendPushContactToFoundationRequest();
                            }
                        }
                    }
                    else {
                        $('.push-to-foundation-loader-' + contact.id).hide();
                    }
                });
            }
            else {
                self.selectedContactForPushFoundation = contact;
                if(contact.is_contact_residential) {
                    if(self.isContactHasCustomCustomerNoField && !self.isContactCustomCustomerNoAutoGenerated) {
                        self.external_custom_fields = self.contact_custom_fields;
                        self.externalCustomFieldModalTitle = 'Foundation Custom Customer #';
                        $('#pushContactToFoundationModal').modal('show');
                    }
                    else {
                        self.sendPushContactToFoundationRequest();
                    }
                }
                else {
                    if(!contact.is_any_contact_synced_to_foundation && self.isCompanyHasCustomCustomerNoField && !self.isCompanyCustomCustomerNoAutoGenerated) {
                        self.external_custom_fields = self.company_custom_fields;
                        self.externalCustomFieldModalTitle = 'Foundation Custom Customer #';
                        $('#pushContactToFoundationModal').modal('show');
                    }
                    else {
                        self.sendPushContactToFoundationRequest();
                    }
                }
            }
        },
        sendPushContactToFoundationRequest(isCustomFieldRequired = false) {
            let self = this;
            self.foundationContactPushLoader = true;
            if(isCustomFieldRequired && (self.externalFoundationCustomFieldValue === undefined || self.externalFoundationCustomFieldValue === null || self.externalFoundationCustomFieldValue === '')) {
                self.foundationContactPushLoader = false;
                Swal.fire({
                    title: 'Error',
                    text: "Please enter Foundation customer #",
                    type: 'error',
                    showCancelButton: false,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: 'OK!',
                    closeOnConfirm: false,
                });
            }
            else {
                let addedContactIds = _.map(self.company_contacts, 'id');
                let payload = {
                    'contact': self.selectedContactForPushFoundation,
                    'customerNo': self.externalFoundationCustomFieldValue,
                    'isContactHasCustomCustomerNoField': self.isContactHasCustomCustomerNoField,
                    'isContactCustomCustomerNoAutoGenerated': self.isContactCustomCustomerNoAutoGenerated,
                    'isCompanyHasCustomCustomerNoField': self.isCompanyHasCustomCustomerNoField,
                    'isCompanyCustomCustomerNoAutoGenerated': self.isCompanyCustomCustomerNoAutoGenerated,
                };
                axios.post(route('api.project.foundation.push-contact'), payload).then((result) => {
                    self.foundationContactPushLoader = false;
                    self.closePushContactToFoundationModal();
                    $('#pushContactToFoundationModal').modal('hide');
                    $('.push-to-foundation-loader-' + self.selectedContactForPushFoundation.id).hide();
                    self.updateAddedContactsAfterFoundationPush(addedContactIds);
                    Swal.fire({
                        title: result.data.foundationCustomerNo ? 'Created' : 'Foundation Error',
                        text: result.data.message,
                        type: result.data.foundationCustomerNo ? 'success' : 'error',
                        showCancelButton: false,
                        confirmButtonColor: '#01B1AF',
                        confirmButtonText: 'OK!',
                        closeOnConfirm: false,
                    }).then(() => {
                        //Call function to refresh added contact list to switch push to foundation button with radio button
                    });
                }).catch(() => {
                    self.foundationContactPushLoader = false;
                    self.closePushContactToFoundationModal();
                    $('#pushContactToFoundationModal').modal('hide');
                    $('.push-to-foundation-loader-' + self.selectedContactForPushFoundation.id).hide();
                    Swal.fire({
                        title: 'Foundation Error',
                        text: "Create/Update on Foundation Failed.",
                        type: 'error',
                        showCancelButton: false,
                        confirmButtonColor: '#01B1AF',
                        confirmButtonText: 'OK!',
                        closeOnConfirm: false,
                    });
                });
            }
        },
        closePushContactToFoundationModal() {
            this.externalFoundationCustomFieldValue = null;
            $('.push-to-foundation-loader-' + this.selectedContactForPushFoundation.id).hide();
        },
        switchToExistingTab() {
            this.resetCreateForm();
            this.activeTab = 1;
        },
        saveContact() {
            event.preventDefault();
            if(this.validate_companies){
                if (this.newContactForm.existing_company === null && (this.newContactForm.new_company === null || this.newContactForm.new_company.trim() === "")){
                    this.customErrors.existing_company = 'You have to choose the Existing Company or New Company!';
                    this.customErrors.new_company = 'You have to choose the Existing Company or New Company!';
                    return false
                }
            }
            let data = {
                existing_company: this.newContactForm.existing_company ? this.newContactForm.existing_company.id : null,
                new_company: this.newContactForm.new_company,
                check_email: true,
                triggerAutomation: true
            }

            this.newContactForm.post(route('api.add-contact', {data: data})).then((response) => {
                if (response.exists){
                    this.emailExists = true;
                    this.existingContact = response.existingContact;
                    this.getToast().fire({
                        type: 'error',
                        title: response.message,
                    });
                }else {
                    if(response.new_contact){
                        response.new_contact.user = response.new_contact.user?.name || null;
                        this.company_contacts.push(response.new_contact);
                        this.resetCreateForm();
                    }
                }
            });
        },
        addContactToProject(){
            if(this.existingContact){
                this.company_contacts.push(this.existingContact);
                this.resetCreateForm();
            }
        },
        remove_validations(){
            if (this.newContactForm.existing_company !== null || this.newContactForm.new_company !== ''){
                this.customErrors.existing_company = '';
                this.customErrors.new_company = '';
            }
        },
        removeMeeting(index) {
            this.company_contacts[index].date = null;
            this.company_contacts[index].completed = null;
        },
        goToCompany(companyId, contact) {
            if(!contact.is_residential_company){
                window.location = route('company.show', {company: companyId});
            }
        },
        goToContact(companyId, contactId) {
            window.location = route('contact.edit', {company: companyId, contact: contactId});
        },
        addOrRemoveContact(contact) {
            this.contactAddedAlready(contact) ? this.removeContact(contact) : this.addContact(contact);
        },
        async addContact(contact, fromCreate = false) {
            if(fromCreate){
                let contactsID = '';
                if(contact.contact_company_unique_id){
                    contactsID = contact.contact_company_unique_id;
                }else{
                    contactsID = contact.company_id+'-'+contact.id;
                }
                await this.fetchCompanyContacts([contactsID], null, this.columnsToShow);
            }else{
                this.company_contacts.push(contact);

            }

            if(this.sectionType === 'projectEdit' || this.sectionType === 'projectCopy'){
                if (this.statusLostDisabled.length > 0 && !this.isLostDisabled(contact)) {
                    const key = 'contact_status_won_disabled_' + contact.company_id;
                    if (!this.statusWonDisabled.some(entry => entry.hasOwnProperty(key))) {
                        this.statusWonDisabled.push({ [key]: true });
                    }
                }
            }
        },
        removeContact(contact) {
            this.company_contacts = this.company_contacts.filter(function (addedContact) {
                return addedContact.contact_company_unique_id !== contact.contact_company_unique_id;
            });

            if(this.sectionType === 'projectEdit' || this.sectionType === 'projectCopy'){
                const companyContacts = this.company_contacts.filter(function (company_contact) {
                    return company_contact.company_id === contact.company_id;
                });
                const existingWonCompany = companyContacts.find(contact => contact.status === 'won')

                if (companyContacts.length === 0 || !existingWonCompany) {
                    const key = 'contact_status_lost_disabled_' + contact.company_id;
                    const index = this.statusLostDisabled.findIndex(entry => Object.keys(entry)[0] === key);
                    if (index !== -1) {
                        this.statusLostDisabled.splice(index, 1);
                    }

                    const keyWon = 'contact_status_won_disabled_' + contact.company_id;
                    const indexWon = this.statusWonDisabled.findIndex(entry => Object.keys(entry)[0] === keyWon);
                    if (indexWon !== -1) {
                        this.statusWonDisabled.splice(index, 1);
                    }
                }

                if(this.statusLostDisabled.length === 0) {
                    this.statusWonDisabled = [];
                }
            }
        },
        setContactStatusWonORLostDisabled(company_contacts){
            company_contacts.map(company_contact => {
                if(company_contact.status === 'won'){
                    const key = 'contact_status_lost_disabled_' + company_contact.company_id;
                    this.statusLostDisabled.push({ [key]: true });
                }
                const tempKey = 'contact_status_lost_disabled_' + company_contact.company_id;
                if(!['lost', 'lost-gc-awarded', 'lost-gc-not-awarded'].includes(company_contact.status) && !this.statusLostDisabled.find(entry => entry[tempKey] === true) && this.statusLostDisabled.length > 0){
                    const key = 'contact_status_won_disabled_' + company_contact.company_id;
                    this.statusWonDisabled.push({ [key]: true });
                }

                if(['lost', 'lost-gc-awarded', 'lost-gc-not-awarded'].includes(company_contact.status) ){
                    const key = 'contact_status_won_disabled_' + company_contact.company_id;
                    this.statusWonDisabled.push({ [key]: true });
                }
            })
        },
        isLostDisabled(contact) {
            const key = 'contact_status_lost_disabled_' + contact.company_id;
            const disabledEntry = this.statusLostDisabled.find(entry => entry[key] === true);
            return disabledEntry !== undefined;
        },
        isWonDisabled(contact) {
            const key = 'contact_status_won_disabled_' + contact.company_id;
            const disabledEntry = this.statusWonDisabled.find(entry => entry[key] === true);
            return disabledEntry !== undefined;
        },
        resetCompanyContactStatusValidation() {
            this.$parent.resetCompanyContactStatusValidation();
        },
        checkAndRemoveKeys(contact) {
            if (['pending', 'no-bid', ''].includes(contact.status)) {
                const companyWonContacts = this.company_contacts.filter(addedContact => {
                    return addedContact.company_id === contact.company_id && addedContact.status === 'won';
                });

                const companyLostContacts = this.company_contacts.filter(addedContact => {
                    return addedContact.company_id === contact.company_id && addedContact.status === 'lost';
                });

                if (companyLostContacts.length === 0) {
                    const key = 'contact_status_won_disabled_' + contact.company_id;
                    const index = this.statusWonDisabled.findIndex(entry => Object.keys(entry)[0] === key);
                    if (index !== -1) {
                        this.statusWonDisabled.splice(index, 1);
                    }
                }

                if (companyWonContacts.length === 0) {
                    const key = 'contact_status_lost_disabled_' + contact.company_id;
                    const index = this.statusLostDisabled.findIndex(entry => Object.keys(entry)[0] === key);
                    if (index !== -1) {
                        this.statusLostDisabled.splice(index, 1);
                    }
                }

                if (this.statusLostDisabled.length === 0) {
                    this.statusWonDisabled = [];
                }
            }

            if(contact.status === 'won'){
                const keyLost = 'contact_status_lost_disabled_' + contact.company_id;
                const lostIndex = this.statusLostDisabled.findIndex(entry => Object.keys(entry)[0] === keyLost);
                if (lostIndex === -1) {
                    this.statusLostDisabled.push({ [keyLost]: true });
                }
                const otherCompanyIds = [...new Set(this.company_contacts.map(addedContact => addedContact.company_id))]
                    .filter(companyId => companyId !== contact.company_id);

                otherCompanyIds.forEach(companyId => {
                    const key = 'contact_status_won_disabled_' + companyId;
                    const index = this.statusWonDisabled.findIndex(entry => Object.keys(entry)[0] === key);
                    if (index === -1) {
                        this.statusWonDisabled.push({ [key]: true });
                    }
                });
            }

            if(['lost', 'lost-gc-awarded', 'lost-gc-not-awarded'].includes(contact.status)){
                const keyWon = 'contact_status_won_disabled_' + contact.company_id;
                const wonIndex = this.statusLostDisabled.findIndex(entry => Object.keys(entry)[0] === keyWon);
                if (wonIndex === -1) {
                    this.statusWonDisabled.push({ [keyWon]: true });
                }
            }
        },
        openCompanyContactModal(contact, index) {
            this.$refs.companyContactDetailModal.open(contact, index);
        },
        saveContactData(contact) {
            this.company_contacts[contact.index].date = contact.date;
            this.company_contacts[contact.index].completed = contact.completed;
            this.company_contacts[contact.index].status = contact.status;
        },
        debounceFilter(event) {
            clearTimeout(this.filter.timeout);
            const inputValue = event.target.value;
            if (inputValue.length > 2) {
                this.filter.timeout = setTimeout(() => {
                    if(event.target.value === ''){
                        this.isLoadingContacts = false;
                    }else{
                        this.isLoadingContacts = true;
                        this.fetchCompanyAndContacts(event.target.value);
                    }
                }, 700, this);
            }
            this.addToolTipForContacts();
        },
        fetchCompanyAndContacts(filter) {
            this.filter.company_name = filter;
            axios.post(route('api.project.companies-contacts'), {filter: this.filter.company_name}).
            then(({data}) => {
                this.contacts = data.data;
                this.isLoadingContacts = false;
            }).catch(error => {
                    this.isLoadingContacts = false;
            });
            this.addToolTipForContacts();
        },
        updateCompanyInformationSection() {
          this.fetchState();
        },
        fetchSalesBehaviorData(contact, column){
            const saleBehaviorData = contact.sales_behavior_data.find(salesBehavior =>  salesBehavior.id === column.sales_behavior_id);
            if(saleBehaviorData !== null && saleBehaviorData !== undefined) {
                if(this.team.has_calendar_access){
                    return saleBehaviorData.date ? moment(saleBehaviorData.date).local().format('YYYY-MM-DD hh:mm A') : '';
                }else{
                    return saleBehaviorData.date ? moment(saleBehaviorData.date).local().format('YYYY-MM-DD') : '';
                }
            }
        },
        saveColumnWidths(columnWidths) {
            axios.post(route('api.project-company-information-state.store-width'), {column_widths: columnWidths}).then(response=>{
            })
        },
        getColumnWidth(columnName) {
            return this.columnWidths[columnName] || 150; // Default width if not set
        },
        setResizeListeners(){
            const table = this.$refs.ResizableTable;
            if(table){
                const columnHeaders = table.querySelectorAll('th.column-header-resize');

                // Initialize variables to track resizing state
                let isResizing = false;
                let initialX = 0;
                let initialWidth = 0;
                let resizedColumnIndex = -1;
                let propertyName = '';

                // Function to handle the start of resizing
                const startResize = (event, columnIndex) => {
                    isResizing = true;
                    initialX = event.clientX;
                    initialWidth = columnHeaders[columnIndex].offsetWidth;
                    resizedColumnIndex = columnIndex;

                    // Prevent text selection during resizing
                    document.body.style.userSelect = 'none';
                    propertyName = columnHeaders[columnIndex].getAttribute('id');

                    // Attach event listeners for mousemove and mouseup
                    document.addEventListener('mousemove', handleResize);
                    document.addEventListener('mouseup', stopResize);
                };

                // Function to handle the resizing
                const handleResize = (event) => {
                    if (!isResizing) return;

                    const deltaX = event.clientX - initialX;
                    const newWidth = initialWidth + deltaX;

                    if (newWidth > 0) {
                        columnHeaders[resizedColumnIndex].style.width = newWidth + 'px';
                        this.columnWidths[propertyName] = newWidth;
                    }
                };

                // Function to stop resizing
                const stopResize = () => {
                    if (!isResizing) return;

                    // Cleanup: Remove event listeners and reset state
                    document.removeEventListener('mousemove', handleResize);
                    document.removeEventListener('mouseup', stopResize);
                    isResizing = false;
                    initialX = 0;
                    initialWidth = 0;
                    resizedColumnIndex = -1;
                    propertyName = '';

                    // Restore text selection
                    document.body.style.userSelect = 'auto';

                    this.$nextTick(()=>{
                        this.saveColumnWidths(this.columnWidths); // Replace with your save function
                    })
                };

                // Attach mousedown event listeners to each column header
                columnHeaders.forEach((th, index) => {
                    th.addEventListener('mousedown', (event) => startResize(event, index));
                });
            }
        },
        removeNewContactDate() {
            this.newContactForm.date = null;
        },
        initAutocompleteCompanyContact() {
            let input = document.getElementById('searchTextFieldCompanyContact');
            autocomplete = new google.maps.places.Autocomplete(input, {
                componentRestrictions: {
                    country: ['us','ca']
                }
            });
            google.maps.event.addListener(autocomplete, 'place_changed', this.getAddressComponentsCompanyContact);
        },
        getAddressComponentsCompanyContact() {
            let placeResultData = autocomplete.getPlace();
            this.newContactForm.lat = placeResultData.geometry.location.lat();
            this.newContactForm.lng = placeResultData.geometry.location.lng();
            this.newContactForm.zip = '';
            this.newContactForm.city = '';
            this.newContactForm.state = '';
            placeResultData.address_components.map(res=>{
                if(res.types[0]==='postal_code'){
                    this.newContactForm.zip = res.short_name;
                }
                if(res.types[0]==='locality'){
                    this.newContactForm.city = res.short_name;
                }
                if(res.types[0]==='administrative_area_level_1'){
                    this.newContactForm.state = res.short_name;
                }
            });
            this.newContactForm.address = placeResultData.name;
        },
        checkContactAlreadyExists(contactId, companyId) {
            const index = _.findIndex(this.company_contacts, {'id': contactId, 'company_id': companyId});
            return index !== -1;
        },
        addToolTipForContacts(){
            setTimeout(() => {
                $(".tooltips-company-title-class, .tooltips-company-selected-title-class").tooltip('dispose');
                $(".tooltips-company-title-class, .tooltips-company-selected-title-class").tooltip();
            }, 2000);
        },
        triggerCompanyContactsWatcher() {
            this.$options.watch.company_contacts.handler.call(this, this.company_contacts, this.company_contacts);
        },
        loadCompanies() {
            this.isLoadingCompanies = true;
            this.currentPage = 1;

            axios.post(route('api.project.companies-search'), {
                query: this.companySearchQuery || null,
                page: this.currentPage,
                per_page: this.perPage
            }).then(({data}) => {
                this.allCompanies = data.data;
                this.lastPage = data.last_page;
                this.totalItems = data.total;
                this.isLoadingCompanies = false;
            }).catch(error => {
                this.isLoadingCompanies = false;
            });
        },
        searchCompanies(query) {
            this.isLoadingCompanies = true;
            this.searchQuery = query;
            this.currentPage = 1; // Reset to first page on new search

            axios.post(route('api.project.companies-search'), {
                query: query,
                page: this.currentPage,
                per_page: this.perPage
            }).then(({data}) => {
                this.allCompanies = data.data;
                this.lastPage = data.last_page;
                this.totalItems = data.total;
                this.isLoadingCompanies = false;
            }).catch(error => {
                this.isLoadingCompanies = false;
            });
        },
        loadMoreCompanies() {
            if (this.currentPage >= this.lastPage || this.isLoadingMore) return;

            this.isLoadingMore = true;
            this.currentPage++;

            axios.post(route('api.project.companies-search'), {
                query: this.searchQuery,
                page: this.currentPage,
                per_page: this.perPage
            }).then(({data}) => {
                this.allCompanies = [...this.allCompanies, ...data.data];
                this.isLoadingMore = false;
            }).catch(error => {
                this.isLoadingMore = false;
            });
        },
        debounceCompanySearch() {
            clearTimeout(this.companySearchTimeout);
            this.companySearchTimeout = setTimeout(() => {
                this.companyPage = 1;
                this.hasMoreCompanies = true;
                this.loadCompanies();
            }, 300);
        },
        async loadCompanies() {
            if (!this.hasMoreCompanies) return;

            this.isLoadingCompanies = true;
            try {
                const response = await axios.post(route('api.project.companies-search'), {
                    query: this.companySearchQuery || null,
                    page: this.companyPage,
                    per_page: this.companyPerPage
                });

                if (this.companyPage === 1) {
                    this.searchedCompanies = response.data.data;
                } else {
                    this.searchedCompanies = [...this.searchedCompanies, ...response.data.data];
                }

                this.hasMoreCompanies = this.companyPage < response.data.last_page;
            } catch (error) {
                console.error('Error loading companies:', error);
            } finally {
                this.isLoadingCompanies = false;
            }
        },
        handleCompanyScroll(event) {
            const dropdown = event.target;
            if (dropdown.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 20) {
                this.loadMoreCompanies();
            }
        },
        async loadMoreCompanies() {
            if (this.isLoadingMoreCompanies || !this.hasMoreCompanies) return;

            this.isLoadingMoreCompanies = true;
            this.companyPage++;
            await this.loadCompanies();
            this.isLoadingMoreCompanies = false;
        },
        selectCompany(company) {
            this.newContactForm.existing_company = company;
            this.displayValue = company.name;
            this.showCompanyDropdown = false;
            this.remove_validations();
            this.newContactForm.errors.clear('existing_company');
        },
        handleClickOutside(event) {
            const dropdown = this.$refs.companyDropdown;
            const container = this.$refs.companyDropdownContainer;

            if (dropdown && container && !container.contains(event.target)) {
                this.showCompanyDropdown = false;
            }
        },
        handleCompanyInput(event) {
            this.companySearchQuery = event.target.value;
            this.newContactForm.existing_company = null;
            this.debounceCompanySearch();
        },
    },
    computed: {
        isNewCompanyInputDisabled() {
            return !this.canCreateCompany || !!((this.selectedContactType && this.selectedContactType.is_residential) || (this.newContactForm.existing_company && this.newContactForm.existing_company !== ''));
        },
        isExistingCompanyInputDisabled() {
            return !!((this.selectedContactType && this.selectedContactType.is_residential) || (this.newContactForm.new_company && this.newContactForm.new_company !== ''));
        },
        isCreateDisabled() {
            return !!(!this.newContactForm.name || this.newContactForm.name === '');
        },
        shouldShowCreateSection() {
            return this.sectionType === 'projectCreate' || this.isProjectCreateRoute();
        }
    },


}
</script>
<style>
.company-information-section .company-contact-margin {
  margin-top: 0 !important;
  margin-left: 0 !important;
}
.company-information-section .custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  color: #fff !important;
  background-color: #6f7174 !important;
  border-color: #6f7174 !important;
}
.custom-search-icon{
    top: 2px;
    right: 0;
}
.contact-result-section{
    height: auto;
    max-height: 250px;
    overflow-y: auto;
}
.company-dropdown {
    max-height: 200px;
    overflow-y: auto;
}
</style>
<style lang="scss" scoped>

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}


#project_index {
    border-collapse: collapse;
    border-spacing: 0px;
    overflow: scroll;
}

#project_index th.column-header-resize {
    padding: 0;
    margin: 0px;
}

#project_index th.column-header-resize div.column-resize {
    resize: horizontal;
    overflow: hidden;
    min-width: 90%;
    margin: 0px;
    padding: 0px;
    display: block;
    border: 0;
}

#project_index td.td-text-overflow {
    overflow: hidden;
}

#project_index th:last-child,
#project_index td:last-child {
    position: sticky;
    right: 0;
    border-left: 1px solid;
    background: #ffffff;
}

.company-dropdown-container {
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: rgba(155, 155, 155, 0.5) transparent;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(155, 155, 155, 0.5);
        border-radius: 20px;
        border: transparent;
    }
}

.company-dropdown-list {
    width: 100%;
}

.company-dropdown-item {
    padding: 8px 12px;
    transition: background-color 0.2s ease;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
        background-color: #f3f4f6;
    }
}

// Remove the old company-dropdown class if it exists
.company-dropdown {
    display: none;
}
#create-new-tab #new_company[disabled] {
    background: #dedede !important;
}
</style>
